import { Link, useNavigate, useParams } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";
import { newsList } from "@/mocks/news";
import Breadcrumb from "@/components/feature/Breadcrumb";
import EmptyState from "@/components/feature/EmptyState";
import NewsCard from "@/components/feature/NewsCard";

export default function NewsDetailPage() {
  const { id = "" } = useParams();
  const navigate = useNavigate();
  const news = newsList.find((n) => n.id === id);

  usePageMeta({
    title: news ? `${news.title} - CC视频资讯` : "资讯详情 - CC视频",
    description: news ? news.summary : "CC视频影视资讯详情。",
    keywords: news ? `${news.category},影视资讯,CC视频` : "CC视频资讯",
  });

  if (!news) {
    return (
      <div className="max-w-content mx-auto px-4 md:px-6 py-16">
        <EmptyState
          icon="ri-article-line"
          title="未找到该资讯"
          description="内容可能已被移除，返回资讯列表查看更多内容。"
          actionLabel="返回资讯列表"
          onAction={() => navigate("/news")}
        />
      </div>
    );
  }

  const related = newsList.filter((n) => n.id !== news.id).slice(0, 3);

  return (
    <div className="max-w-content mx-auto px-4 md:px-6 py-6 md:py-8">
      <Breadcrumb
        items={[
          { label: "首页", to: "/" },
          { label: "影视资讯", to: "/news" },
          { label: news.title },
        ]}
      />

      <article className="mt-5 max-w-3xl mx-auto">
        <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs">
          {news.category}
        </span>
        <h1 className="mt-3 text-2xl md:text-3xl font-heading font-bold text-foreground-950 leading-snug">
          {news.title}
        </h1>
        <p className="mt-3 text-sm text-foreground-400">发布于 {news.date}</p>

        <div className="mt-6 w-full aspect-[16/9] rounded-lg overflow-hidden bg-background-200">
          <img
            src={news.cover}
            alt={`${news.title} 配图`}
            title={`${news.title} - CC视频资讯`}
            className="w-full h-full object-cover object-top"
          />
        </div>

        <div className="mt-6 space-y-4 text-sm md:text-base text-foreground-700 leading-loose">
          <p className="text-foreground-800 font-medium">{news.summary}</p>
          {news.content.map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </div>

        <div className="mt-8 flex items-center justify-between pt-6 border-t border-background-200">
          <Link
            to="/news"
            className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1"
          >
            <i className="ri-arrow-left-line"></i>
            返回资讯列表
          </Link>
        </div>
      </article>

      {related.length > 0 && (
        <section className="mt-12">
          <h2 className="text-xl font-heading font-bold text-foreground-950 flex items-center gap-2 mb-5">
            <span className="w-1.5 h-6 rounded-full bg-accent-500"></span>
            相关资讯
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {related.map((item) => (
              <NewsCard key={item.id} news={item} variant="block" />
            ))}
          </div>
        </section>
      )}
    </div>
  );
}